// extracted by mini-css-extract-plugin
module.exports = {"modal-video-container":"ModalVideo_modal-video-container__zNp3C","modal-video":"ModalVideo_modal-video__4UO4S","modal-video-inner":"ModalVideo_modal-video-inner__CzYeS"};